import React from 'react'
import { Select } from '@ztechapps/webui.input'
import { productStatusOptions } from './productStatusOptions'

export const ProductStatusSelect = ({ ...rest }) => {
  return (
    <Select
      {...{
        ...rest,
        options: productStatusOptions,
      }}
    />
  )
}
